import { create } from "zustand";

export const useErrorStore = create((set, get) => ({
  error: null, // Об'єкт помилки { id, message }
  isVisible: false,
  timerId: null,

  // Функція для відображення помилки
  showError: (message) => {
    // Якщо вікно вже відображається, видаляємо стариий таймер
    if (get().timerId) {
      clearTimeout(get().timerId);
    }

    // Створюємо новий таймер на 60 секунд
    const newTimerId = setTimeout(() => {
      get().hideError();
    }, 60000);

    // Встановлюємо нову помилку і робимо її видимою
    set({
      error: { id: Date.now(), message },
      isVisible: true,
      timerId: newTimerId,
    });
  },

  // Функція для закриття вікна помилки
  hideError: () => {
    if (get().timerId) {
      clearTimeout(get().timerId);
    }
    set({ isVisible: false, timerId: null });
  },
}));
